import * as React from "react";
import { styled } from "styled-components";

import { Field, FieldLabel, ValidationError } from "affinityUI/form/components";
import { RadioButton } from "affinityUI/form/inputs/radioButton";

import { useAffinityField } from "../../helpers";

export const RadioButtons = styled.div`
  display: grid;
  padding: 0.5rem 0;
  grid-auto-flow: column;
  grid-template-columns: auto;
  grid-gap: 1.5rem;
  width: fit-content;
`;

export const RadioGroupField: React.FC<
  Omit<React.ComponentProps<typeof RadioButton>, "name"> & {
    name: string;
    options: Array<{ id: string; label: string }>;
  }
> = ({ children, name, options, ...otherProps }) => {
  const [field, { error }] = useAffinityField(name);
  const { value, ...fieldProps } = field;
  const groupId = `field-${name}`;

  return (
    <Field role="group" aria-labelledby={groupId}>
      <FieldLabel id={groupId}>{children}</FieldLabel>
      <RadioButtons id={name}>
        {options.map(({ id, label }) => (
          <RadioButton
            label={label}
            key={id}
            id={id}
            value={id}
            checked={id === value}
            error={error}
            {...fieldProps}
            {...otherProps}
          />
        ))}
      </RadioButtons>
      {error && <ValidationError>{error}</ValidationError>}
    </Field>
  );
};
